import { all, call, put, takeEvery } from "redux-saga/effects";
import * as actions from "../slices/salesSlice";
import salesApis from "src/api/salesOrder";
import { common } from "src/types";
import { constants } from "src/constants/common";

function* GetSalesListSaga({
  payload,
}: ReturnType<typeof actions.getSalesListRequest>) {
  try {
    const response: common.ResponseGenerator = yield call(
      salesApis.getSalesList,
      payload
    );
    yield put(actions.getSalesListSuccess(response));
  } catch (error) {
    yield put(
      actions.getSalesListError(
        error instanceof Error
          ? error.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
  }
}

function* CreateSalesOrderSaga({
  payload,
}: ReturnType<typeof actions.createSalesOrderRequest>) {
  try {
    const response: common.ResponseGenerator = yield call(
      salesApis.createSalesOrder,
      payload
    );
    yield put(actions.createSalesOrderSuccess(response as any));
  } catch (error) {
    yield put(
      actions.createSalesOrderError(
        error instanceof Error
          ? error.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
  }
}

function* EditSalesOrderSaga({
  payload,
}: ReturnType<typeof actions.editSalesOrderRequest>) {
  try {
    const response: common.ResponseGenerator = yield call(
      salesApis.updateSalesOrder,
      payload.id,
      payload.data
    );
    yield put(actions.editSalesOrderSuccess(response as any));
  } catch (error) {
    yield put(
      actions.editSalesOrderError(
        error instanceof Error
          ? error.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
  }
}

export default function* salesSaga() {
  yield all([
    takeEvery(actions.getSalesListRequest.type, GetSalesListSaga),
    takeEvery(actions.createSalesOrderRequest.type, CreateSalesOrderSaga),
    takeEvery(actions.editSalesOrderRequest.type, EditSalesOrderSaga),
  ]);
}
